
import { Button } from "@/components/ui/button";
import { LogIn, Sparkles } from "lucide-react";

interface NavigationBarProps {
  onLoginClick: () => void;
  onDemoClick: () => void;
}

export const NavigationBar = ({ onLoginClick, onDemoClick }: NavigationBarProps) => {
  return (
    <nav className="fixed top-4 right-4 flex gap-2 z-10">
      <Button variant="outline" onClick={onDemoClick} className="flex items-center gap-2">
        <Sparkles className="h-4 w-4 text-teal-500" />
        Try Demo
      </Button>
      <Button variant="outline" onClick={onLoginClick} className="flex items-center gap-2">
        <LogIn className="h-4 w-4 text-teal-500" />
        Login
      </Button>
    </nav>
  );
};
